import React, { useState } from 'react'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import { InfiniteData } from 'react-query'
import InfiniteScroll from 'react-infinite-scroll-component'
import NewUserIcon from 'assets/images/fund/new-user.svg'
import { useNavigate, useParams } from 'react-router'
import { CiSearch } from 'react-icons/ci'
interface IFundUsersProps {
    data: InfiniteData<IGetMoneyPoolUsers>
    isLoading: boolean
    onWatchEnd: () => void
    shareValueAmount: number
    isManager: boolean
    setIsOpenPayToOtherModal: React.Dispatch<React.SetStateAction<boolean>>
    setSelectUser: React.Dispatch<
        React.SetStateAction<IMoneyPoolResults | undefined>
    >
    setSearchUser: React.Dispatch<React.SetStateAction<string>>
    search: string
    setSearch: React.Dispatch<React.SetStateAction<string>>
    refetch: () => void
}
export default function Users({
    data,
    isLoading,
    onWatchEnd,
    shareValueAmount,
    isManager,
    setIsOpenPayToOtherModal,
    setSelectUser,
    setSearchUser,
    search,
    setSearch,
    refetch,
}: IFundUsersProps) {
    const navigate = useNavigate()
    const { id } = useParams()
    return (
        <>
            {isManager && (
                <div className="mx-4 my-3 flex items-center">
                    <img
                        src={NewUserIcon}
                        alt="add-user"
                        onClick={() => navigate(`/fund/add-new-user/${id}`)}
                    />
                    <p
                        className=" mx-2"
                        onClick={() => navigate(`/fund/add-new-user/${id}`)}
                    >
                        افزودن عضو جدید
                    </p>
                </div>
            )}
            <div className="flex mx-4 h-[25px]">
                <input
                    type="text"
                    className=" w-full outline-0 border border-green-1 rounded-full px-2 py-1 ml-3"
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                    placeholder="جستجو..."
                />
                <CiSearch
                    className=" text-green-1  w-8 h-full cursor-pointer"
                    onClick={() => {
                        setSearchUser(search)
                    }}
                />
            </div>
            <InfiniteScroll
                next={onWatchEnd}
                hasMore={
                    data
                        ? data?.pages[data.pages.length - 1].next
                            ? true
                            : false
                        : false
                }
                dataLength={
                    data
                        ? data.pages.flatMap((x) => x.results).length
                            ? data.pages.flatMap((x) => x.results).length
                            : 0
                        : 0
                }
                loader={<DotsLoading />}
            >
                <div>
                    {data && !isLoading ? (
                        <>
                            {data.pages
                                .flatMap((x) => x.results)
                                .map((item) => (
                                    <div key={item.id}>
                                        {item.is_active && (
                                            <Item
                                                isManager={isManager}
                                                item={item}
                                                shareValueAmount={
                                                    shareValueAmount
                                                }
                                                setSelectUser={setSelectUser}
                                                setIsOpenPayToOtherModal={
                                                    setIsOpenPayToOtherModal
                                                }
                                                refetch={refetch}
                                            />
                                        )}
                                    </div>
                                ))}
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </InfiniteScroll>
        </>
    )
}
